import { OPTION_ITEM } from 'models';
import { REQUEST_DETAIL_PET } from 'models/create-request';

export const dataPets: REQUEST_DETAIL_PET[] = [
  { id: '1', name: 'Cats' },
  { id: '2', name: 'Dogs' },
];

export const ageRangeOptions: OPTION_ITEM<number>[] = [
  { id: 0, name: '0 - 1 months' },
  { id: 1, name: '2 - 12 months' },
  { id: 2, name: '1 - 3 years old' },
  { id: 3, name: '4 - 6 years old' },
  { id: 4, name: '7 - 12 years old' },
  { id: 5, name: '13+ years old' },
];

export const daysOfWeekOptions = [
  { id: 1, name: 'Mon', fullName: 'Monday' },
  { id: 2, name: 'Tue', fullName: 'Tuesday' },
  { id: 3, name: 'Wed', fullName: 'Wednesday' },
  { id: 4, name: 'Thu', fullName: 'Thursday' },
  { id: 5, name: 'Fri', fullName: 'Friday' },
  { id: 6, name: 'Sat', fullName: 'Saturday' },
  { id: 7, name: 'Sun', fullName: 'Sunday' },
];

export const terms = [
  {
    title: 'Search Fee',
    type: 'search-fee',
    isRequired: true,
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    ],
  },
  {
    title: 'Trial',
    type: 'trial',
    isRequired: true,
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    ],
  },
  {
    title: 'Packages',
    type: 'packages',
    isRequired: true,
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    ],
  },
  {
    title: 'Non-Solicitation',
    type: 'non-solicitation',
    isRequired: false,
    descriptions: [
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    ],
  },
];

export interface TermsSubSection {
  content: string;
}

export interface TermsSection {
  title: string;
  isRequired: boolean;
  descriptions: string[];
}
